// extracted by mini-css-extract-plugin
export var modal_want = "ModalWant-module--modal_want--7c26K";
export var modal_content = "ModalWant-module--modal_content--7LUdP";
export var modal_content_thanks = "ModalWant-module--modal_content_thanks--2MoUJ";
export var description = "ModalWant-module--description--3f0us";
export var button = "ModalWant-module--button--n70F6";